export const APP_URL = process.env.REACT_APP_KAREDB_URL;
export const ADMIN_URL = process.env.REACT_APP_ADMIN_URL;
export const API_KEY = process.env.REACT_APP_MAP_KEY;

export const HOSPITAL_CONTEXT = "HOSPITAL";
export const DOCTOR_CONTEXT = "DOCTOR";

export const hospital_document = "hospital_document";
export const hospital_image = "hospital_image";
export const hospital_domestic_agreement = "hospital_domestic_agreement";
export const hospital_international_agreement =
  "hospital_international_agreement";
export const doctor_image = "doctor_image";
export const doctor_agreement = "doctor_agreement";
export const doctor_medical_council_document =
  "doctor_medical_council_document";
export const hospital_exterior_image = "hospital_exterior_image";
export const hospital_logo = "hospital_logo";
export const hospital_interior_image = "hospital_interior_image";
